import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["for"]

import Tooltip from "./tooltip.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'textInput',
  props: /*#__PURE__*/_mergeModels({
    id: {},
    name: {},
    label: {},
    type: {},
    tooltip: {},
    placeholder: {},
    min: {},
    max: {},
    step: {},
    valid: { type: Boolean },
    validationMessage: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;

const model = _useModel(__props, "modelValue");

const onChange = (event: Event) => {
  const target = event.target as HTMLSelectElement;
  model.value = target.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", {
      class: "form-label",
      for: _ctx.id
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1 /* TEXT */),
      _createVNode(Tooltip, { tooltip: _ctx.tooltip }, null, 8 /* PROPS */, ["tooltip"])
    ], 8 /* PROPS */, _hoisted_1),
    _createElementVNode("input", _mergeProps({ id: _ctx.id, name: _ctx.name, label: _ctx.label, type: _ctx.type, tooltip: _ctx.tooltip, placeholder: _ctx.placeholder, min: _ctx.min, max: _ctx.max, step: _ctx.step }, {
      onInput: onChange,
      value: model.value,
      class: "input-text__input valid"
    }), null, 16 /* FULL_PROPS */, _hoisted_2),
    (!_ctx.valid && !!_ctx.validationMessage)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id,
          class: "error"
        }, null, 8 /* PROPS */, _hoisted_3))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})